import { useAuthentication } from '@providers/AuthProvider';
import {
  AccountType,
  Container,
  Name,
  PicContainer,
  PopupArrow,
  PopupWhiteSpace,
  Profile,
  TextContainer,
  UserAccountType,
  UserContainer,
  UserName,
  UserPopup,
} from './UserProfile.styled';
import { useStore } from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import React, { memo, useEffect, useState } from 'react';
import ProfilePic from '@components/ProfilePic';
import Arrow from '@assets/svg/chevron-down.svg';
import { mq } from '@styles/helpers';
import { Devices, breakpoints } from '@styles/tokens';
import { useWindowSize } from 'react-use';
import StudentThumbnail from '@components/StudentThumbnail';

interface Props {
  className?: string;
  showPicture?: boolean;
  usingTopMenu?: boolean;
}

export const UserProfile = (props: Props) => {
  const { user, login, logout } = useAuthentication();
  const { client, settings, whoIsLoggedIn, setWhoIsLoggedIn, groups, setGroups, setMenuOpen, schoolName } = useStore();
  const [active, setActive] = useState(false);
  const i18n = useI18n();
  const { width } = useWindowSize();
  const demoUsers = [
    { firstname: 'Demo', lastname: 'student' },
    { firstname: 'Demo', lastname: 'teacher' },
    { firstname: 'Demo', lastname: 'admin' },
    { firstname: 'Demo', lastname: 'caseworker' },    
    { firstname: 'Demo', lastname: 'leader' },
    { firstname: 'Demo', lastname: 'parent' },
    { firstname: 'Demo', lastname: 'secretary' },
  ];

  useEffect(() => {
    if (!settings) {
      return;
    }
  }, [settings]);

  const setDemoUser = (id) => {
    if (id === 0) {
      setWhoIsLoggedIn(demoUsers[0].firstname, demoUsers[0].lastname);
      setGroups(['Attender_Students'?.toLowerCase()?.replace(/\s/g, '')]);
    }

    if (id === 1) {
      setWhoIsLoggedIn(demoUsers[1].firstname, demoUsers[1].lastname);
      setGroups(['Attender_Teacher'?.toLowerCase()?.replace(/\s/g, '')]);
    }

    if (id === 2) {
      setWhoIsLoggedIn(demoUsers[2].firstname, demoUsers[2].lastname);
      setGroups(['Attender_Admins'?.toLowerCase()?.replace(/\s/g, ''), 'Attender_CoinAdmin'?.toLowerCase()?.replace(/\s/g, ''), "RewardShopClerk".toLowerCase()?.replace(/\s/g, ''), "RewardAdmin".toLowerCase()?.replace(/\s/g, '')]);
    }

    if (id === 3) {
      setWhoIsLoggedIn(demoUsers[3].firstname, demoUsers[3].lastname);
      setGroups(['caseworker']);
    }    

    if (id === 4) {
      setWhoIsLoggedIn(demoUsers[4].firstname, demoUsers[4].lastname);
      setGroups(['leader', 'attender_admins']);
    }

    if (id === 5) {
      setWhoIsLoggedIn(demoUsers[5].firstname, demoUsers[5].lastname);
      setGroups(['guardian']);
    }

    if (id === 6) {
      setWhoIsLoggedIn(demoUsers[6].firstname, demoUsers[6].lastname);
      setGroups(['secretary']);
    }    

    setMenuOpen(false);
  };

  return (
    <>
      {user && client && (
        <Profile onClick={() => (settings.DEMO === 'true' ? setActive(!active) : null)} active={active} topMenu={props.usingTopMenu}>          
          <Container topMenu={props.showPicture}>
            <PicContainer show={props.showPicture}>
              <StudentThumbnail graph={true} demo={settings.DEMO === 'true' || settings.DEMO === true ? whoIsLoggedIn.lastname : null} font={"1.7em"} name={`${i18n.t(whoIsLoggedIn.firstname)} ${i18n.t(whoIsLoggedIn.lastname)}`} src={null} />

              {/* <ProfilePic demoImage={settings.DEMO === 'true' ? whoIsLoggedIn.lastname : null} /> */}
            </PicContainer>
            <TextContainer topMenu={props.usingTopMenu}>
              {whoIsLoggedIn && (
                <Name topMenu={props.usingTopMenu}> {`${i18n.t(whoIsLoggedIn.firstname)} ${i18n.t(whoIsLoggedIn.lastname)}`} </Name>
              )}
              <AccountType topMenu={props.usingTopMenu}>
                {groups
                  ? groups?.includes(client?.SchoolLeaderGroupName)
                    ? i18n.t('leader')
                    : groups?.includes(client?.RegisterGroupName)
                    ? i18n.t(client.TeacherTitle[i18n.language])
                    : groups?.includes(client?.StudentGroupName)
                    ? i18n.t(client.StudentTitle[i18n.language])
                    : groups?.includes(client.GuardianGroupName)
                    ? i18n.t('guardian')
                    : groups?.includes(client?.CaseWorkerGroupName)
                    ? i18n.t('caseworker')
                    : groups?.includes(client?.AdminGroupName)
                    ? i18n.t('admin')
                    : groups?.includes(client?.SchoolSecretaryGroupName)
                    ? i18n.t('secretary')
                    : 'UNKNOWN'
                  : 'UNKNOWN'}
              </AccountType>
            </TextContainer>
          </Container>
          <PopupArrow show={settings.DEMO}>
            <Arrow />
          </PopupArrow>
          <UserPopup show={settings.DEMO}>
            <PopupWhiteSpace>
              {(settings.DEMO === 'true' || settings.DEMO === true)?demoUsers.map((u, index) => {
                if (whoIsLoggedIn.lastname?.toLowerCase() === u.lastname?.toLowerCase()) return;                            
                if(width <= breakpoints.mobile && (u.lastname === 'caseworker'))return;
                if(width <= breakpoints.laptop && (u.lastname === 'leader' ||u.lastname === 'secretary'))return;
                return (
                  <UserContainer onClick={() => setDemoUser(index)} key={'users_' + index} topMenu={props.showPicture}>
                    <PicContainer show={props.showPicture}>
                      <StudentThumbnail graph={true} demo={settings.DEMO === 'true' || settings.DEMO === true ? u.lastname : null} font={"1.7em"} name={`${i18n.t(u.firstname)} ${i18n.t(u.lastname)}`} src={null} />
                      {/* <ProfilePic demoImage={u.lastname} /> */}
                    </PicContainer>
                    <TextContainer topMenu={props.usingTopMenu}>
                      <UserName topMenu={props.usingTopMenu}> {`${i18n.t(u.firstname)} ${i18n.t(u.lastname)}`} </UserName>
                      <UserAccountType topMenu={props.usingTopMenu}>
                        {u.lastname.includes('admin') ||
                        u.lastname.includes('teacher') ||
                        u.lastname.includes('student') ||
                        u.lastname.includes('parent') ||
                        u.lastname.includes('caseworker') ||
                        u.lastname.includes('leader') ||
                        u.lastname.includes('secretary')
                          ? i18n.t(u.lastname)
                          : 'UNKNOWN'}
                      </UserAccountType>
                    </TextContainer>
                  </UserContainer>
                );
              }):null}
            </PopupWhiteSpace>
          </UserPopup>
        </Profile>
      )}
    </>
  );
};

export default memo(UserProfile);
